<template>
  <div class="ph-nav">
    <div class="ph-nav-container">
      <router-link to="/">
        <img src="../assets/img/logo.jpg" />
      </router-link>

      <div class="ph-menubtn" @click="toggleMenu">
        <svg
          width="60"
          height="58"
          viewBox="0 0 14 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="10" width="14" height="1.6" rx="0.8" fill="#005574" />
          <rect y="5" width="14" height="1.6" rx="0.8" fill="#005574" />
          <rect width="14" height="1.6" rx="0.8" fill="#005574" />
        </svg>
      </div>
    </div>

    <!-- 사이드 메뉴 -->
    <div class="side-menu" :class="{ open: isMenuOpen }">
      <!-- 닫기 버튼 -->
      <button class="close-menu" @click="toggleMenu">✕</button>

      <!-- 로그인 상태 영역 -->
      <div class="side-menu-header">
        <template v-if="isLoggedIn">
          <div class="auth-links">
            <div class="user-name">{{ userName }}님</div>
            <button class="sub-button" @click="logout">로그아웃</button>
            <button class="sub-button" @click="goToMyPage">마이페이지</button>
          </div>
        </template>
        <template v-else>
          <div class="auth-links">
            <button class="sub-button" @click="goToLogin">로그인</button>
            <button class="sub-button" @click="goToSignup">회원가입</button>
            <button class="sub-button" @click="goToFindAccount">
              아이디/비밀번호 찾기
            </button>
          </div>
        </template>
      </div>

      <ul>
        <!-- 소개 -->
        <li>
          <div class="menu-item" @click="toggleSubMenu('intro')">
            소개
            <span class="arrow" :class="{ open: openSubMenus.intro }">▾</span>
          </div>
          <ul v-if="openSubMenus.intro" class="submenu">
            <li>
              <router-link :to="{ name: 'about' }">신대승네트워크</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'people' }"
                >함께하는 사람들</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'inquiry' }">문의하기</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'contact' }">오시는 길</router-link>
            </li>
          </ul>
        </li>

        <!-- 활동 -->
        <li>
          <div class="menu-item" @click="toggleSubMenu('activity')">
            활동
            <span class="arrow" :class="{ open: openSubMenus.activity }"
              >▾</span
            >
          </div>
          <ul v-if="openSubMenus.activity" class="submenu">
            <li v-for="board in activityBoards" :key="board.idx">
              <router-link
                :to="{ name: 'activity', params: { id: board.idx } }"
              >
                {{ board.etc }}
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 공지 -->
        <li>
          <div class="menu-item" @click="toggleSubMenu('notice')">
            공지
            <span class="arrow" :class="{ open: openSubMenus.notice }">▾</span>
          </div>
          <ul v-if="openSubMenus.notice" class="submenu">
            <li v-for="board in newsBoards" :key="board.idx">
              <router-link
                :to="
                  Number(board.boardtype) === 2
                    ? { name: 'thumbnailBoard', params: { id: board.idx } }
                    : { name: 'notice', params: { id: board.idx } }
                "
              >
                {{ board.etc }}
              </router-link>
            </li>
          </ul>
        </li>

        <!-- 소모임 -->
        <li>
          <div class="menu-item" @click="toggleSubMenu('community')">
            소모임
            <span class="arrow" :class="{ open: openSubMenus.community }"
              >▾</span
            >
          </div>
          <ul v-if="openSubMenus.community" class="submenu">
            <li
              v-for="(communities, groupName) in groupedCommunities"
              :key="groupName"
            >
              <div class="group-header">{{ groupName }}</div>
              <ul class="sub-menu">
                <li v-for="community in communities" :key="community.idx">
                  <a @click.prevent="checkLogin3(community.idx)">
                    {{ community.etc }}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <!-- 상담 -->
        <li>
          <div class="menu-item" @click="toggleSubMenu('counsel')">
            상담
            <span class="arrow" :class="{ open: openSubMenus.counsel }">▾</span>
          </div>
          <ul v-if="openSubMenus.counsel" class="submenu">
            <li>
              <router-link :to="{ name: 'onlineCounselingGuide' }"
                >온라인상담실 안내</router-link
              >
            </li>
            <li>
              <router-link :to="{ name: 'chatRoom' }">채팅상담실</router-link>
            </li>
            <li><a @click="checkLogin">게시판상담실</a></li>
            <li><a @click="checkLogin2">회원게시판</a></li>
          </ul>
        </li>

        <!-- 후원 -->
        <li>
          <div class="menu-item" @click="toggleSubMenu('donate')">
            후원
            <span class="arrow" :class="{ open: openSubMenus.donate }">▾</span>
          </div>
          <ul v-if="openSubMenus.donate" class="submenu">
            <li>
              <a
                href="https://view.hyosungcms.co.kr/shorten-url/jD4coQmur8"
                target="_blank"
              >
                정기후원하기
              </a>
            </li>
            <li>
              <router-link :to="{ name: 'donationGuide' }"
                >정기후원 안내</router-link
              >
            </li>
          </ul>
        </li>

        <!-- 자료실 -->
        <li>
          <div class="menu-item" @click="toggleSubMenu('resources')">
            자료실
            <span class="arrow" :class="{ open: openSubMenus.resources }"
              >▾</span
            >
          </div>
          <ul v-if="openSubMenus.resources" class="submenu">
            <li v-for="board in resourcesBoards" :key="board.idx">
              <router-link
                :to="
                  Number(board.boardtype) === 2
                    ? { name: 'thumbnailBoard', params: { id: board.idx } }
                    : { name: 'notice', params: { id: board.idx } }
                "
              >
                {{ board.etc }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div v-if="isMenuOpen" class="overlay" @click="toggleMenu"></div>
  </div>
</template>

<script>
import axios from "axios";
import cc from "@/js/commonData.js";
import checkSession from "@/js/checkSession.js";

export default {
  data() {
    return {
      isMenuOpen: false,
      openSubMenus: {
        intro: false,
        activity: false,
        notice: false,
        community: false,
        counsel: false,
        donate: false,
        resources: false,
      },
      boards: [],
      activityBoards: [],
      newsBoards: [],
      resourcesBoards: [],
      communityData: [],
      domainUrl: cc.getDomain(),

      isLoggedIn: false,
      userName: "",
    };
  },
  computed: {
    groupedCommunities() {
      const grouped = {};
      this.communityData.forEach((item) => {
        const group = item.groupname?.trim();
        if (!grouped[group]) grouped[group] = [];
        grouped[group].push(item);
      });
      return grouped;
    },
  },
  watch: {
    //라우트 변경 시 메뉴 자동 닫기
    "$route.fullPath"() {
      this.isMenuOpen = false;
      Object.keys(this.openSubMenus).forEach((key) => {
        this.openSubMenus[key] = false;
      });

      this.checkLoginStatus();
    },
  },
  mounted() {
    this.getBoardList();
    this.getCommunityList();
    this.checkLoginStatus();
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (!this.isMenuOpen) {
        Object.keys(this.openSubMenus).forEach(
          (key) => (this.openSubMenus[key] = false)
        );
      }
    },
    toggleSubMenu(menuKey) {
      this.openSubMenus[menuKey] = !this.openSubMenus[menuKey];
    },

    goToLogin() {
      this.$router.push({ name: "login" });
      this.isMenuOpen = false;
      Object.keys(this.openSubMenus).forEach((key) => {
        this.openSubMenus[key] = false;
      });
    },

    goToSignup() {
      this.$router.push({ name: "terms" });
      this.isMenuOpen = false;
      Object.keys(this.openSubMenus).forEach((key) => {
        this.openSubMenus[key] = false;
      });
    },

    goToFindAccount() {
      this.$router.push({ name: "find" });
      this.isMenuOpen = false;
      Object.keys(this.openSubMenus).forEach((key) => {
        this.openSubMenus[key] = false;
      });
    },

    goToMyPage() {
      this.$router.push({ name: "mypageInfo" });
      this.isMenuOpen = false;
      Object.keys(this.openSubMenus).forEach((key) => {
        this.openSubMenus[key] = false;
      });
    },

    async checkLoginStatus() {
      const sessionData = await checkSession.getSession();
      //console.log("세션 데이터 확인:", sessionData);
      //console.log("id 값 확인:", sessionData?.id);

      if (sessionData && sessionData["id"] !== "-1") {
        //console.log("유효한 세션 감지");
        this.userName = sessionData["name"];
        this.isLoggedIn = true;
        // this.loginInfo.id = "";
        // this.loginInfo.pass = "";
      } else {
        // console.log("세션 데이터가 없습니다.");
        /// todo: 로그인 실패 처리
        /// 로그인창으로 route
        //console.log("세션 없음 또는 유효하지 않음");
        this.isLoggedIn = false;
        //return;
      }
    },

    async logout() {
      await checkSession.logOut();

      this.userName = "";
      this.isLoggedIn = false;
      this.isMenuOpen = false;

      alert("로그아웃이 되었습니다.");
      this.$router.push("/");
    },

    async getCommunityList() {
      try {
        const response = await axios({
          method: "post",
          url: this.domainUrl + "/community_list.php",
          withCredentials: true,
        });

        this.communityData = response["data"]["res_communityData"];
        //console.log("nav 응답 데이터:", response);
      } catch (error) {
        console.error("커뮤니티 목록을 가져오는 중 에러:", error);
      }
    },

    async getBoardList() {
      try {
        const response = await axios({
          method: "post",
          url: this.domainUrl + "/board_name_list.php",
          withCredentials: true,
        });

        this.datacount = response["data"]["res_datacnt"];
        this.boards = response["data"]["res_boardData"];
        // console.log("nav 응답 데이터:", response);
        // console.log("boardtype", response.data.res_boardData[4].boardtype);

        // 데이터 필터링하여 activityBoards에 저장
        this.activityBoards = (this.boards || [])
          .filter((item) => item.groupname?.trim() === "활동")
          .sort((a, b) => Number(a.idx) - Number(b.idx));

        // 데이터 필터링하여 newsBoards에 저장
        this.newsBoards = (this.boards || [])
          .filter((item) => item.groupname?.trim() === "공지")
          .sort((a, b) => Number(a.idx) - Number(b.idx));

        // 데이터 필터링하여 resourcesBoard 저장
        this.resourcesBoards = (this.boards || [])
          .filter((item) => item.groupname?.trim() === "자료실")
          .sort((a, b) => Number(a.idx) - Number(b.idx));
      } catch (error) {
        console.error("게시판 목록을 가져오는 중 에러:", error);
      }
    },

    async checkLogin() {
      const session = await checkSession.getSession();
      if (session.id === "-1") {
        alert("로그인 후 이용해주세요.");
        this.$router.push("/login");
      } else {
        this.$router.push({ name: "counselingRoom" });
      }
    },

    async checkLogin2() {
      const session = await checkSession.getSession();
      if (session.id === "-1") {
        alert("로그인 후 이용해주세요.");
        this.$router.push("/login");
      } else {
        this.$router.push({ name: "memberBoard" });
      }
    },

    async checkLogin3(idx) {
      this.$router.push({ name: "communityboards", params: { id: idx } });
      // const session = await checkSession.getSession();
      // if (session.id === "-1") {
      //   alert("로그인 후 이용해주세요.");
      //   this.$router.push("/login");
      // } else {
      //   this.$router.push({ name: "communityboards", params: { id: idx } });
      // }
    },
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

.ph-nav {
  display: none;
}

@media all and (max-width: 479px) {
  .ph-nav {
    display: flex;
    border-bottom: 1px solid #ddd;
    position: fixed;
    top: 0;
    width: 100%;
    background-color: #ffffff;
    z-index: 999;
  }

  .ph-nav-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px 16px;
  }

  .ph-nav-container img {
    width: 180px;
    max-width: 100%;
    height: auto;
  }

  .ph-menubtn svg {
    width: 36px;
    max-width: 100%;
  }

  .side-menu {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-width: 250px;
    height: 100%;
    background-color: #fff;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1000;
    padding: 40px 20px;
    overflow-y: auto;
  }

  .close-menu {
    position: absolute;
    top: 20px;
    right: 12px;
    background: transparent;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #005574;
  }

  .side-menu.open {
    transform: translateX(0);
  }

  .side-menu-header {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
    margin-bottom: 30px;
    align-items: center;
  }

  .login-button {
    background-color: #fff;
    color: #005574;
    border: 1px solid #005574;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
  }

  .user-name {
    margin-left: 10px;
    font-weight: bold;
    width: 100%;
    text-align: left;
  }

  .auth-links {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
    align-items: center;
  }

  .sub-button {
    font-size: 14px;
    padding: 8px 16px;
    background-color: #ffffff;
    color: #00796f;
    border: 1px solid #00796f;
    border-radius: 5px;
    cursor: pointer;
    width: 100%;
    max-width: 200px;
  }

  .side-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .side-menu li {
    margin-bottom: 20px;
    font-size: 18px;
  }

  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 999;
  }

  .menu-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .arrow {
    transition: transform 0.3s ease;
  }

  .arrow.open {
    transform: rotate(180deg);
  }

  .submenu {
    text-align: left;
  }

  .submenu li {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .submenu li a {
    text-decoration: none;
    color: #000;
  }

  .submenu li a:hover {
    color: #03754e;
  }

  .group-header {
    font-weight: bold;
    margin: 10px 0 5px;
  }

  .sub-menu {
    padding-left: 10px;
  }
}
</style>
